module.exports = __webpack_public_path__ + "static/media/furniture-8.d4f56eef.jpg";